import { Boundaries } from "@planzone/core";
import { Group, Identifiable } from "@planzone/dto";

function handleAddResourceToResourceGroupRequest(
  group: Identifiable<Group>,
  req: Boundaries["addResourceToResourceGroup"]["request"],
): Identifiable<Group> {
  return group.uuid === req.group.uuid
    ? { ...group, resources: [...group.resources, req.resource] }
    : group;
}

function handleAddResourceToResourceGroupSuccess(
  group: Identifiable<Group>,
  req: Boundaries["addResourceToResourceGroup"]["success"],
): Identifiable<Group> {
  if (group.uuid !== req.group.uuid) return group;

  const index = group.resources.findIndex((resource) =>
    group.resourceType === "project"
      ? resource.resource.uuid === req.resource.uuid
      : resource.uuid === req.resource.uuid,
  );

  return {
    ...group,
    resources:
      index !== -1
        ? [
            ...group.resources.slice(0, index),
            req.resource,
            ...group.resources.slice(index + 1),
          ]
        : [...group.resources, req.resource],
  };
}

function handleAddResourceToResourceGroupFailure(
  group: Identifiable<Group>,
  req: Boundaries["addResourceToResourceGroup"]["failure"],
): Identifiable<Group> {
  return group.uuid === req.group.uuid
    ? {
        ...group,
        resources: group.resources.filter((resource) =>
          group.resourceType === "project"
            ? resource.resource.uuid !== req.resource.uuid
            : resource.uuid !== req.resource.uuid,
        ),
      }
    : group;
}

function handleAddEveryoneToResourceGroupSuccess(
  group: Identifiable<Group>,
  req: Boundaries["addEveryoneToResourceGroup"]["success"],
): Identifiable<Group> {
  return group.uuid === req.group.uuid
    ? {
        ...group,
        resources: [
          ...group.resources,
          ...req.resources.filter(
            ({ uuid }) => !group.resources.find((r) => r.uuid === uuid),
          ),
        ],
      }
    : group;
}

export {
  handleAddEveryoneToResourceGroupSuccess,
  handleAddResourceToResourceGroupRequest,
  handleAddResourceToResourceGroupSuccess,
  handleAddResourceToResourceGroupFailure,
};
